import { createSelector, Selector } from 'reselect';
import { State } from '../../../../store/reducers';
import { selectCurrentCaseProjection } from '../../projection/currentCase/projection.selector';
import { Property } from '../../../../domain/specification/cases/Property';

export const selectCurrentCaseProperties: Selector<State, Property[]> = createSelector(
  [selectCurrentCaseProjection],
  (currentCase) => (currentCase ? currentCase.properties : [])
);
